<template>
  <div
    :class="{
      'wrapper': true,
      'wrapper_sidebar': right
    }"
  >
    <i
      :class="{
        'gg-chevron-left': true,
        'gg-chevron-right': right
      }"
    ></i>
  </div>
</template>

<script>

export default {
  name: 'BaseChevron',
  props: {
    right: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  top: 0;
  left: 0;

  &_sidebar {
    top: 3px;
    left: 7px;
  }

  &:hover {
    .gg-chevron-left::after {
      color: #6D6D6D;
      transition: 0.5s;
    }
  }
}

.gg-chevron-left {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs,1));
  width: 22px;
  height: 22px;
  border: 2px solid transparent;
  border-radius: 100px;
}

.gg-chevron-left::after {
  content: "";
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid;
  border-left: 2px solid;
  transform: rotate(45deg);
  left: 6px;
  top: 4px;
  color: #000000;
  transition: 0.5s;
}

.gg-chevron-right {
  transform: rotate(180deg);
}

</style>
